import React, { Component } from "react"
import ComparisonPercentage from "./ComparisonPercentage"

class DualComparisonPercentage extends Component {
  render() {
    const showLeftComparison = this.props.leftComparisonTitle && this.props.leftComparisonValue
    const showRightComparison = this.props.rightComparisonTitle && this.props.rightComparisonValue

    return (
      <div>
        {(showLeftComparison || showRightComparison) && (
          <div className="row">
            <div className="col-sm-6">
              {showLeftComparison && (
                <div>
                  <h6>{this.props.leftComparisonTitle}</h6>
                  <ComparisonPercentage
                    base={this.props.currentValue}
                    compare={this.props.leftComparisonValue}
                  />
                </div>
              )}
            </div>
            <div className="col-sm-6" style={{ textAlign: "right" }}>
              {showRightComparison && (
                <div>
                  <h6>{this.props.rightComparisonTitle}</h6>
                  <ComparisonPercentage
                    base={this.props.currentValue}
                    compare={this.props.rightComparisonValue}
                  />
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default DualComparisonPercentage



// WEBPACK FOOTER //
// ./src/Components/Graphs/Shared/DualComparisonPercentage.js